.section {
  padding-block: var(--section-spacing);
}

.container {
  width: min(calc(100% - (var(--page-margin) * 2)), var(--container-max));
  margin-inline: auto;
}

.header {
  display: flex;
  max-width: 52rem;
  margin-bottom: var(--space-xl);
  flex-direction: column;
  gap: var(--space-s);
}

.title {
  font-size: var(--font-size-section);
  font-weight: var(--font-weight-semibold);
  letter-spacing: -0.01em;
  line-height: var(--line-height-section);
  text-wrap: balance;
}

.subtitle {
  color: var(--color-text-primary);
  font-size: var(--font-size-subheading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-subheading);
}

.intro,
.storyCopy {
  max-width: var(--text-width-body);
  color: var(--color-text-secondary);
  line-height: var(--line-height-body);
}

.story {
  display: grid;
  margin-top: var(--space-xl);
  grid-template-columns: repeat(12, minmax(0, 1fr));
  align-items: center;
  gap: var(--grid-gutter);
}

.collage {
  position: relative;
  min-height: 42rem;
}

.storyGraffiti .collage {
  grid-column: 6 / -1;
}

.storyGraffiti .storyCopy {
  grid-row: 1;
  grid-column: 1 / span 4;
}

.storyThreads .collage {
  grid-column: 1 / span 7;
}

.storyThreads .storyCopy {
  grid-column: 9 / -1;
}

.primaryFrame,
.detailFrame {
  position: absolute;
  margin: 0;
  overflow: hidden;
  border-radius: var(--image-radius);
  background: #0a0a0a;
  will-change: clip-path;
}

.primaryFrame {
  inset: 0 10% 8% 0;
}

.detailFrame {
  z-index: var(--z-content);
  right: 0;
  bottom: 0;
  width: 34%;
  height: 58%;
  box-shadow: 0 1.5rem 4rem rgb(0 0 0 / 45%);
}

.storyImage {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform var(--duration-normal) ease;
}

.storyGraffiti .detailFrame .storyImage {
  object-position: center left;
}

.threadsPhoto {
  object-position: center right;
}

.storyCopy {
  display: flex;
  flex-direction: column;
  gap: var(--space-s);
}

.storyIndex {
  color: var(--color-text-muted);
  font-family: var(--font-display);
  font-size: var(--font-size-caption);
  font-weight: var(--font-weight-medium);
  letter-spacing: var(--letter-spacing-ui);
}

.storyCopy > p:first-of-type {
  color: var(--color-text-primary);
  font-size: var(--font-size-subheading);
  font-weight: var(--font-weight-medium);
  line-height: var(--line-height-subheading);
}

.data {
  padding-top: var(--space-s);
  border-top: 1px solid var(--color-border);
}

@media (hover: hover) and (pointer: fine) {
  .primaryFrame:hover .storyImage,
  .detailFrame:hover .storyImage {
    transform: scale(var(--scale-hover));
  }
}

@media (max-width: 63.9375rem) {
  .container {
    width: min(calc(100% - (var(--page-margin) * 2)), 48rem);
  }

  .header {
    margin-bottom: var(--space-l);
  }

  .story {
    display: flex;
    margin-top: var(--space-l);
    flex-direction: column;
    align-items: stretch;
    gap: var(--space-m);
  }

  .collage {
    width: 100%;
    min-height: 38rem;
  }

  .storyCopy {
    max-width: 80%;
  }
}

@media (max-width: 47.9375rem) {
  .section {
    padding-block: var(--space-l);
  }

  .container {
    width: 100%;
  }

  .header,
  .storyCopy {
    width: calc(100% - (var(--page-margin) * 2));
    max-width: none;
    margin-inline: auto;
  }

  .header {
    margin-bottom: var(--space-m);
  }

  .story {
    margin-top: var(--space-m);
    gap: var(--space-s);
  }

  .collage {
    width: 100vw;
    min-height: 31rem;
  }

  .primaryFrame {
    inset: 0 0 18% 0;
    border-radius: 0;
  }

  .detailFrame {
    right: var(--page-margin);
    width: 38%;
    height: 48%;
  }

  .storyCopy > p:first-of-type {
    font-size: var(--font-size-subheading);
  }
}
